import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, the } from './customStyles';

const ScriptDropdown = ({ allScripts, selectedMarket, onScriptChange }) => {
    const [scripts, setScripts] = useState([]);
    const [selectedScript, setSelectedScript] = useState(null); 

    useEffect(() => {
        if (selectedMarket) {
            const marketScripts = allScripts[selectedMarket] || {};
            const scriptData = Object.keys(marketScripts).map(category => ({
                label: category,
                value: category
            }));
            setScripts(scriptData);
        } else {
            setScripts([]); 
            setSelectedScript(null); 
        }
    }, [selectedMarket, allScripts]);

    const handleScriptDropdownChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedScript(selectedOption.value);
            onScriptChange(selectedOption.value); 
        } else {
            setSelectedScript(null); 
            onScriptChange(null); 
        }
    };

    return (
            <Col>
                <Select
                    options={scripts}
                    value={scripts.find(script => script.value === selectedScript) || null} 
                    onChange={handleScriptDropdownChange}
                    isMulti={false}
                    theme={the}
                    styles={customStyles}
                    isClearable 
                    placeholder="Select"
                />
            </Col>
    );
};

export default ScriptDropdown;
